import {
  convertFiscalPeriodToYear,
  convertFiscalYearToPeriod
} from '../../../master/securitiesReportInfo/extra/helpers'

/**
 * QuickSight / company の accPeriod（例: 3月 / 3）を helper 用に正規化する
 *
 * @param {string | number | null | undefined} accPeriod
 * @returns {string}
 */
export function normalizeAccPeriodLabel(accPeriod) {
  if (accPeriod == null || accPeriod === '') {
    return ''
  }
  const text = String(accPeriod)
  if (text.includes('月')) {
    return text
  }
  const month = parseInt(text, 10)
  if (Number.isNaN(month)) {
    return ''
  }
  return `${month}月`
}

/**
 * QS の YYYY年度 から 10.6.1 の表示対象（年○月期）を決める
 *
 * @param {string[]} yearOptions
 * @param {string | undefined} selectedFiscalYear 例: 2024年度
 * @param {string | number | null | undefined} accPeriod
 * @returns {string}
 */
export function resolveFiscalPeriodOption(yearOptions, selectedFiscalYear, accPeriod) {
  if (!yearOptions?.length) {
    return ''
  }
  const acc = normalizeAccPeriodLabel(accPeriod)
  if (!selectedFiscalYear || !acc) {
    return yearOptions[0]
  }
  try {
    const period = convertFiscalYearToPeriod(selectedFiscalYear, acc)
    if (yearOptions.includes(period)) {
      return period
    }
  } catch {
    // 変換失敗時は先頭へフォールバック
  }
  return yearOptions[0]
}

/**
 * 10.6.1 の年○月期 → QS の YYYY年度
 *
 * @param {string} fiscalPeriod
 * @param {string | number | null | undefined} accPeriod
 * @returns {string | null}
 */
export function fiscalPeriodToQsYear(fiscalPeriod, accPeriod) {
  const acc = normalizeAccPeriodLabel(accPeriod)
  if (!fiscalPeriod || !acc) {
    return null
  }
  try {
    return convertFiscalPeriodToYear(fiscalPeriod, acc)
  } catch {
    return null
  }
}
